export default function browserRedirect() {
  var sUserAgent = navigator.userAgent.toLowerCase()
  console.log(sUserAgent)

  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    // 跳转移动端页面
    console.log('移动端')
    return 'M'
    // this.mobileStatus = mobile(页面通过data的mobileStatus 值做不同样式)
  } else {
    // 跳转pc端页面
    console.log(sUserAgent)
    return 'PC'
    // this.mobileStatus = pc
  }
}

